export default
  {
    smartix: {
      seat: {
        "__seat__": "34"
      },
      row: {
        "__row__": "3",
        "__seat__": "34"
      },
      section: {
        "__row__": "3",
        "__seat__": "34",
        "__section__": "E"
      },
      gate: {
        "__gate__": "B",
        "__row__": "3",
        "__seat__": "34",
        "__section__": "E"
      }
    },
    standard: {
      seat: {
        "seat": "34"
      },
      row: {
        "row": "3",
        "seat": "34"
      },
      section: {
        "row": "3",
        "seat": "34",
        "section": "E"
      },
      gate: {
        "gate": "B",
        "row": "3",
        "seat": "34",
        "section": "E"
      }
    }
  }